// extracted by mini-css-extract-plugin
export default {"wrapper":"BsaHistoryData_wrapper__d4QRz","layout":"BsaHistoryData_layout__OcJdD","content":"BsaHistoryData_content__4CmnH","contentInner":"BsaHistoryData_contentInner__wR2iR"};